import axios, {
    AxiosResponse,
} from 'axios';
import { CONFIG } from '../../config';
import { AxiosError, StatusCodes } from './Configurations';
import { StorageConstants } from '../storage/storageConstants';
import { clearAuthStorage } from '../storage/AuthStorage';
  
const BASE_URL = CONFIG.baseApiUrl;
  
// Create an Axios instance with default configuration
export const axiosBridge = axios.create({
    baseURL: BASE_URL, // Replace with your API base URL
    timeout: 15000, // Timeout in milliseconds
    headers: {
        'Content-Type': 'application/json',
        'x-region': 'Asia/Kolkata',
        'X-PACKAGE-NAME': 'co.starnex.recruiter'
    },
});
  
let controller;
let id;
  
// Add a request interceptor
axiosBridge.interceptors.request.use(
    async (config) => {
        // You can modify the request configuration here
        // For example, add authentication headers or perform transformations
        const token = await localStorage.getItem(StorageConstants.LOGIN_TOKEN);
        const signupToken = await localStorage.getItem(StorageConstants.SIGNUP_TOKEN);
        if (token) {
            config.headers['Authorization'] = `Bearer_${token}`;
        } else if (signupToken) {
            config.headers['Authorization'] = `Bearer_${signupToken}`;
        }
    
        if (controller?.signal?.aborted !== false) controller = new AbortController();
        const signal = controller.signal;
    
        clearTimeout(id);
        id = setTimeout(() => controller.abort(), 15000);
        
        return { ...config, signal };
    },
    (error) => {
        // Handle request errors
        console.log("Axios error req:", error);
        return Promise.reject(error);
    },
  );
  
  // Add a response interceptor
  axiosBridge.interceptors.response.use(
    (response) => {
        // You can modify the response here
        // For example, handle global success scenarios
        clearTimeout(id);
        return response;
    },
    error => {
        // Handle response errors
        clearTimeout(id);
        console.log("Axios error:", error?.response?.data ?? error);
    
        const response = error?.response?.data;
    
        if (!response) {
            return Promise.reject(AxiosError);
        }
    
        if (response?.code === StatusCodes.NOT_ACCEPTABLE || response?.code === StatusCodes.AUTH_FAILED || response?.code === StatusCodes.NO_DATA_FOUND) {
            return { data: response };
        }
    
        if (response?.code === StatusCodes.INVALID_ACCESS) {
            clearAuthStorage()
            sessionStorage.clear();
            // Navigate({ to: "/login", replace: true });
        }
    
        return Promise.reject(response);
    },
  );
  
  
  
  